import { render, staticRenderFns } from "./jsxm.vue?vue&type=template&id=43bb6068&scoped=true"
import script from "./jsxm.vue?vue&type=script&lang=js"
export * from "./jsxm.vue?vue&type=script&lang=js"
import style0 from "./jsxm.vue?vue&type=style&index=0&id=43bb6068&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bb6068",
  null
  
)

export default component.exports